var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Bind")]),_c('v-btn',{on:{"click":function($event){return _vm.getModuleAuthUrl()}}},[_vm._v("前往綁定官方帳號")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }